<template>
  <div class="canvas-container">
    <div>
      <div class="text-brand-5 text-weight-bold assinatura-texto">
        {{ tipoTitulo[tipoAssinatura] }}
      </div>
    </div>

    <div v-if="atividadesCriticas.length > 1" class="row q-mb-md">
      <div class="col-12 text-center">
        <div class="text-brand-5 text-weight-bold" style="font-size: 16px">
          Progresso das Assinaturas:
          {{ assinaturasAssinadas }}/{{ atividadesCriticas.length }}
        </div>
      </div>
    </div>

    <div v-if="atividadesCriticas.length > 1" class="q-mb-md">
      <q-tabs
        v-model="enviarAssinaturaForm.atividadeNome"
        dense
        class="text-grey bg-accent"
        active-color="primary"
        indicator-color="primary"
        align="justify"
        narrow-indicator
      >
        <q-tab
          v-for="atividade in atividadesCriticas"
          :key="atividade"
          :name="atividade"
          :label="atividade"
          :text-color="isAtividadeAssinada(atividade) ? 'positive' : 'negative'"
          :class="{
            'text-positive': isAtividadeAssinada(atividade),
            'text-negative': !isAtividadeAssinada(atividade),
          }"
        />
      </q-tabs>
    </div>

    <div class="row text-brand-5 text-weight-bold">
      <div class="col-12 q-mb-md">
        <q-form class="row">
          <q-checkbox
            class="col-12"
            v-model="enviarAssinaturaForm.participaAtividade"
            label="Participa atividade?"
          />
          <div v-if="!enviarAssinaturaForm.participaAtividade" class="q-ml-sm">
            <p></p>
            <q-btn
              class="q-mt-sm q"
              dense
              outlined
              color="positive"
              label="Enviar"
              icon="check_circle_outline"
              @click="salvarSignature()"
            />
          </div>
        </q-form>
      </div>

      <Canvas
        v-show="enviarAssinaturaForm.participaAtividade"
        class="col-12"
        @update="atualizarImagem"
        v-if="tipoAssinatura === 'manual'"
        :restart="restartSignature"
        :go="saveSignature"
        @assinar="salvarSignature()"
        :tipoAssinatura="tipoAssinatura"
        @remover="verificarAssinaturaRemover()"
      />

      <div
        class="row col-12 q-mt-lg items-center container-autenticacao-pin"
        v-if="tipoAssinatura === 'pin'"
      >
        <q-icon class="q-mr-xs" name="lock" size="28px" />
        <div class="col-md-2 col-xs-6">
          <q-input v-model="pin" type="password" dense outlined />
        </div>
      </div>

      <div
        class="row col-12 q-mt-lg q-ml-md items-center"
        v-if="tipoAssinatura === 'biometria'"
      >
        <div>
          <q-img
            v-if="biometriaVerificacaoConst"
            class="imagem-biometria"
            src="../../../../assets/bioOK.png"
            @click="biometriaModal = true"
          />
          <q-img
            v-else
            class="imagem-biometria"
            src="../../../../assets/bioRequest.png"
            @click="biometriaModal = true"
          />
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
            >Clique no icone da digital para reconhecimento da biometria.</span
          >
          <BiometriaPT
            :modal="biometriaModal"
            :matricula="assinante?.matricula"
            :unidadeId="pt?.unidadeId"
            :titulo="'Verificação de Biometria'"
            :tipoBiometria="'verificacao'"
            @negativePrint="atualizarBiometria"
            @resultadoVerificacao="biometriaVerificacao"
          />
        </div>
      </div>

      <div
        @click="facial = true"
        style="cursor: pointer"
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-assinatura no-wrap"
        v-if="tipoAssinatura === 'facial'"
      >
        <div class="relative-position" style="display: inline-block">
          <q-icon
            size="60px"
            class="q-mr-xs"
            name="face"
            :color="imagemBase64 == null ? 'negative' : 'positive'"
          />

          <q-icon
            :name="imagemBase64 == null ? 'cancel' : 'check_circle'"
            :style="{
              color: imagemBase64 == null ? '#C62828' : '#2E7D32',
            }"
            size="22px"
            class="absolute-bottom-right"
            style="bottom: 2px; right: -2px; z-index: 0"
          >
            <q-tooltip
              anchor="top middle"
              self="bottom middle"
              :class="
                imagemBase64 == null
                  ? 'bg-gray text-white'
                  : 'bg-gray text-white'
              "
            >
              {{
                imagemBase64 == null
                  ? "Face não capturada"
                  : "Face capturada com sucesso"
              }}
            </q-tooltip>
          </q-icon>
        </div>
        <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
          >Clique aqui para reconhecimento da face, após leitura, clique em
          CONFIRMAR FACE</span
        >
        <VerificacaoFacial
          :userId="assinante?.executanteId"
          v-model="facial"
          @close="fecharFacial"
          @sendFace="receberFace"
        />
      </div>

      <div
        class="row col-12 q-mt-lg items-center container-autenticacao-cracha"
        v-if="tipoAssinatura === 'cracha'"
      >
        <div class="relative-position" style="display: inline-block">
          <q-icon
            size="60px"
            class="q-mr-xs"
            name="badge"
            :color="
              codigoCracha == null || codigoCracha == ''
                ? 'negative'
                : 'positive'
            "
          />

          <q-icon
            :name="
              codigoCracha == null || codigoCracha == ''
                ? 'cancel'
                : 'check_circle'
            "
            :style="{
              color:
                codigoCracha == null || codigoCracha == ''
                  ? '#C62828'
                  : '#2E7D32',
            }"
            size="22px"
            class="absolute-bottom-right"
            style="bottom: 2px; right: -2px; z-index: 0"
          >
            <q-tooltip
              anchor="top middle"
              self="bottom middle"
              :class="
                codigoCracha == null || codigoCracha == ''
                  ? 'bg-gray text-white'
                  : 'bg-gray text-white'
              "
            >
              {{
                codigoCracha == null || codigoCracha == ""
                  ? "Código do crachá não inserido"
                  : "Código do crachá inserido"
              }}
            </q-tooltip>
          </q-icon>
        </div>
        <div class="col-md-3 col-xs-6 q-ml-md">
          <div class="text-brand-5 text-weight-bold q-mb-sm">
            Código do Crachá
          </div>
          <q-input
            v-model="codigoCracha"
            dense
            outlined
            placeholder="Digite o código do crachá"
            @input="validarCracha"
          />
        </div>
      </div>
    </div>
    <div
      v-if="
        tipoAssinatura === 'eletronica' ||
        tipoAssinatura === 'pin' ||
        tipoAssinatura === 'facial' ||
        tipoAssinatura === 'biometria'
      "
      class="q-mt-lg"
    >
      <div>
        <q-btn
          label="Confirmar Assinatura"
          color="positive"
          icon="check_circle_outline"
          no-caps
          :disable="
            (tipoAssinatura === 'facial' && imagemBase64 == null) ||
            (tipoAssinatura === 'biometria' && !biometriaVerificacaoConst)
          "
          @click="
            tipoAssinatura === 'facial'
              ? coletarImagem()
              : tipoAssinatura === 'biometria'
              ? coletarBiometriaDigital()
              : coletarAssinatura()
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "@vue/reactivity";
import { useStore } from "vuex";
import Canvas from "./Canvas.vue";
import { useQuasar } from "quasar";
import BiometriaPT from "./BiometriaPT.vue";
import VerificacaoFacial from "../../../requisicao/components/VerificacaoFacial.vue";
export default {
  components: { Canvas, BiometriaPT, VerificacaoFacial },
  props: ["usuarioPodeEditar", "assinante", "atividades", "tipoAssinatura"],
  emits: ["voltar"],

  setup(props, { emit }) {
    const coletar = ref(false);
    let biometriaModal = ref(false);
    const pt = ref(null);
    const tipoTitulo = ref({
      manual: "Assinatura:",
      biometria: "Biometria:",
      pin: "Pin:",
      eletronica: "Assinatura Eletrônica:",
      facial: "Facial:",
    });
    const pin = ref("");
    const facial = ref(false);
    const assinaturaRemoverId = ref("");
    let restartSignature = ref(0);
    let saveSignature = ref(0);
    const biometriaVerificacaoConst = ref(false);
    const enviarAssinaturaForm = ref({
      participaAtividade: true,
      atividadeNome: "geral",
    });
    const listaAtividades = ref([]);
    let atividadeLista = ["geral"];
    let atividadesOptions = ["geral"];
    const atividadesCriticas = ref([]);

    const assinaturasLocais = ref([]);

    const buscarDadosPt = async () => {
      try {
        const ptId = props.assinante?.ptId;

        if (!ptId) {
          console.error("ptId não encontrado nas props do assinante");
          return;
        }

        const response = await store.dispatch("pdt/buscarDetalhePt", {
          ptId: ptId,
        });
        pt.value = response.data.resultado.dados;
      } catch (error) {
        console.warn("Erro ao buscar dados da PT:", error);
      }
    };

    buscarDadosPt();

    const mapearAssinaturaTipo = (tipoAssinatura) => {
      const mapeamento = {
        manual: "manual",
        biometria: "biometrica",
        pin: "pin",
        token: "eletronica",
        eletronica: "eletronica",
        facial: "facial",
      };

      return mapeamento[tipoAssinatura] || tipoAssinatura;
    };

    const adicionarMetadadosAssinatura = (payloadOriginal, tipoOriginal) => {
      if (tipoOriginal === "biometria") {
        payloadOriginal.observacao = `BIOMETRIA_DIGITAL_${Date.now()}`;
      }
      return payloadOriginal;
    };

    try {
      atividadesCriticas.value.push("geral");

      props.atividades.forEach((atividade) => {
        if (atividade.critico) {
          atividadesOptions.push(atividade.nome);
          atividadesCriticas.value.push(atividade.nome);
        }
      });

      enviarAssinaturaForm.value.atividadeNome = "geral";

      if (props.assinante?.assinaturas) {
        assinaturasLocais.value = [...props.assinante.assinaturas];
      }
    } catch (error) {
      console.log(error);
    }

    const assinaturasAssinadas = computed(() => {
      return atividadesCriticas.value.filter((atividade) =>
        assinaturasLocais.value.some(
          (assinatura) => assinatura.atividadeNome === atividade
        )
      ).length;
    });

    let imagemBase64 = ref(null);
    const store = useStore();

    const atualizarImagem = async (value) => {
      imagemBase64.value = value;
      await coletarAssinatura();
    };

    const atualizarBiometria = async (value) => {
      imagemBase64.value = value;
      biometriaModal.value = false;
    };

    const coletarBiometriaDigital = async () => {
      try {
        if (!imagemBase64.value && props.tipoAssinatura == "biometria") {
          quasar.notify({
            message: "A Biometria precisa ser coletada",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
          return;
        }

        if (!biometriaVerificacaoConst.value && imagemBase64.value != null) {
          quasar.notify({
            message:
              "A biometria não coincide com a digital verificada, faça o procedimento novamente ou escolha outro método de autenticação.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
          imagemBase64.value = null;
          return;
        }

        // Verificação adicional para garantir que temos dados válidos
        if (!imagemBase64.value || typeof imagemBase64.value !== "string") {
          quasar.notify({
            message: "Erro: Dados da biometria inválidos. Tente novamente.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
          return;
        }

        // buscarUrl para upload
        const resposta = await store.dispatch("pdt/getUpload", {
          ptId: props.assinante.ptId,
        });

        // inicio upload imagem
        let formAttributes = resposta.data.resultado.dados.formAttributes;
        let formInputs = resposta.data.resultado.dados.formInputs;

        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }

        let imageDataUrl = imagemBase64.value;
        if (
          !imageDataUrl ||
          typeof imageDataUrl !== "string" ||
          !imageDataUrl.startsWith("data:image")
        ) {
          // Se imagemBase64.value não for uma string válida, não podemos continuar
          if (!imagemBase64.value || typeof imagemBase64.value !== "string") {
            throw new Error("Dados da imagem inválidos");
          }
          imageDataUrl = `data:image/png;base64,${imagemBase64.value}`;
        }

        let file;
        try {
          file = await fetch(imageDataUrl).then((res) => {
            if (!res.ok) {
              throw new Error(`Erro no fetch: ${res.status} ${res.statusText}`);
            }
            return res.blob();
          });
        } catch (fetchError) {
          console.error("Erro no fetch da imagem:", fetchError);
          throw new Error(`Falha ao converter imagem: ${fetchError.message}`);
        }

        formData.append("file", file);

        // Upload com Promise para aguardar completar
        await new Promise((resolve, reject) => {
          var request = new XMLHttpRequest();
          request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
              resolve(request.response);
            } else {
              reject(new Error(`Erro no upload: ${request.status}`));
            }
          };
          request.onerror = () => reject(new Error("Erro de rede no upload"));
          request.open(formAttributes.method, formAttributes.action);
          request.send(formData);
        });
        // fim upload imagem

        // Construir URL da assinatura
        const urlAssinatura = `${formAttributes.action}/${formInputs.key}`;

        // Validar se a URL não está muito longa (evitar erro 431)
        if (urlAssinatura.length > 2000) {
          throw new Error("URL da assinatura muito longa");
        }

        // envio da assinatura - IGUAL AO MANUAL
        const payloadBiometria = {
          ptId: props.assinante.ptId,
          assinanteId: props.assinante.executanteId,
          assinanteTipo: "executante",
          assinatura: urlAssinatura,
          assinaturaTipo: "biometrica",
          atividadeNome: enviarAssinaturaForm.value.atividadeNome,
          participaAtividade: enviarAssinaturaForm.value.participaAtividade,
        };

        await store.dispatch("pdt/enviarAssinatura", payloadBiometria);

        quasar.notify({
          message: "Biometria Digital enviada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });

        restartSignature.value += 1;
        imagemBase64.value = null;
        navegarParaProximaAtividade();
      } catch (error) {
        console.error("Erro no fluxo de biometria digital:", error);
        const mensagemErro =
          error?.response?.data?.erro?.mensagem ||
          error.message ||
          "Erro ao processar biometria digital";

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    const coletarBiometria = async () => {
      if (props.tipoAssinatura === "biometrica") {
        return await coletarBiometriaDigital();
      }

      try {
        if (
          enviarAssinaturaForm.value.participaAtividade &&
          imagemBase64.value === undefined &&
          props.tipoAssinatura == "biometrica"
        ) {
          quasar.notify({
            message: "A Biometria precisa ser coletada",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        } else if (
          !biometriaVerificacaoConst.value &&
          imagemBase64.value != null
        ) {
          quasar.notify({
            message:
              "A biometria não concide com o a digital verificada, faça o procedimento novamente ou escolha outro metodo de autenticação.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

          imagemBase64.value = null;
          return;
        }

        // envio da assinatura
        await enviarAssinatura({
          ptId: props.assinante.ptId,
          atividadeNome: enviarAssinaturaForm.value.atividadeNome,
          assinanteId: props.assinante.executanteId,
          assinanteTipo: "executante",
          assinaturaTipo: props.tipoAssinatura,
          participaAtividade: enviarAssinaturaForm.value.participaAtividade,
          assinatura: imagemBase64.value,
        });

        quasar.notify({
          message: "Biometria Enviada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        imagemBase64.value = null;
        coletar.value = false;
      } catch (error) {
        const mensagemErro =
          error?.response?.data?.erro?.mensagem || "Erro ao enviar Biometria";

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const salvarSignature = async () => {
      saveSignature.value++;
    };

    const quasar = useQuasar();

    const navegarParaProximaAtividade = () => {
      setTimeout(() => {
        const proximaAtividade = atividadesCriticas.value.find(
          (atividade) => !isAtividadeAssinada(atividade)
        );

        if (proximaAtividade) {
          enviarAssinaturaForm.value.atividadeNome = proximaAtividade;
        } else {
          emit("voltar");
        }
      }, 100);
    };

    const coletarAssinatura = async () => {
      try {
        if (
          enviarAssinaturaForm.value.participaAtividade &&
          imagemBase64.value === undefined &&
          props.tipoAssinatura == "manual"
        ) {
          quasar.notify({
            message: "A assinatura não pode ser enviada vazia",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }

        if (props.tipoAssinatura == "pin" && !(await verificarPin())) {
          return;
        }

        if (props.tipoAssinatura == "token") {
          enviarAssinatura({
            ptId: props.assinante.ptId,
            atividadeNome: enviarAssinaturaForm.value.atividadeNome,
            assinanteId: props.assinante.executanteId,
            assinanteTipo: "executante",
            assinaturaTipo: "eletronica",
            participaAtividade: enviarAssinaturaForm.value.participaAtividade,
            assinatura: store.state.autenticacao.token,
          });

          quasar.notify({
            message: "Token enviado com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          imagemBase64.value = null;
          coletar.value = false;
          return;
        }

        if (props.tipoAssinatura == "pin") {
          enviarAssinatura({
            ptId: props.assinante.ptId,
            atividadeNome: enviarAssinaturaForm.value.atividadeNome,
            assinanteId: props.assinante.executanteId,
            assinanteTipo: "executante",
            assinaturaTipo: mapearAssinaturaTipo(props.tipoAssinatura),
            participaAtividade: enviarAssinaturaForm.value.participaAtividade,
            assinatura: pin.value,
          });

          quasar.notify({
            message: "PIN enviado com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          imagemBase64.value = null;
          coletar.value = false;
          return;
        }

        if (props.tipoAssinatura == "eletronica") {
          enviarAssinatura({
            ptId: props.assinante.ptId,
            atividadeNome: enviarAssinaturaForm.value.atividadeNome,
            assinanteId: props.assinante.executanteId,
            assinanteTipo: "executante",
            assinaturaTipo: mapearAssinaturaTipo(props.tipoAssinatura),
            participaAtividade: enviarAssinaturaForm.value.participaAtividade,
            assinatura: store.state.autenticacao.token,
          });

          quasar.notify({
            message: "Assinatura eletrônica enviada com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          imagemBase64.value = null;
          coletar.value = false;
          return;
        }

        // buscarUrl para upload
        const resposta = await store.dispatch("pdt/getUpload", {
          ptId: props.assinante.ptId,
        });

        // inicio upload imagem
        let formAttributes = resposta.data.resultado.dados.formAttributes;
        let formInputs = resposta.data.resultado.dados.formInputs;

        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }

        let file = await fetch(imagemBase64.value).then((res) => res.blob());

        formData.append("file", file);
        var request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        await request.send(formData);
        // fim upload imagem

        // envio da assinatura
        enviarAssinatura({
          ptId: props.assinante.ptId,
          atividadeNome: enviarAssinaturaForm.value.atividadeNome,
          assinanteId: props.assinante.executanteId,
          assinanteTipo: "executante",
          assinaturaTipo: mapearAssinaturaTipo(props.tipoAssinatura),
          participaAtividade: enviarAssinaturaForm.value.participaAtividade,
          assinatura: `${formAttributes.action}/${formInputs.key}`,
        });

        quasar.notify({
          message: "Assinatura Enviada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        imagemBase64.value = null;
        coletar.value = false;
      } catch (error) {
        console.error(error);
        quasar.notify({
          message: "Erro a o enviar Assinatura",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const coletarImagem = async () => {
      try {
        if (
          enviarAssinaturaForm.value.participaAtividade &&
          imagemBase64.value === undefined &&
          props.tipoAssinatura == "facial"
        ) {
          quasar.notify({
            message: "A Face precisa ser coletada",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        // envio da assinatura
        await enviarAssinatura({
          ptId: props.assinante.ptId,
          atividadeNome: enviarAssinaturaForm.value.atividadeNome,
          assinanteId: props.assinante.executanteId,
          assinanteTipo: "executante",
          assinaturaTipo: mapearAssinaturaTipo(props.tipoAssinatura),
          participaAtividade: enviarAssinaturaForm.value.participaAtividade,
          assinatura: imagemBase64.value,
        });

        quasar.notify({
          message: "Face Enviada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        imagemBase64.value = null;
        coletar.value = false;
        navegarParaProximaAtividade();
      } catch (error) {
        const mensagemErro =
          error?.response?.data?.erro?.mensagem || "Erro ao enviar Face";

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const verificaAssinaturas = (atividade) => {
      if (atividadeLista.some((e) => e != atividade)) {
        atividadeLista.push(atividade);
      }

      if (atividadeLista.length == atividadesOptions.length) {
        emit("voltar");
        return;
      }
    };

    const verificarAssinaturaRemover = async () => {
      if (props.assinante.assinaturas) {
        props.assinante.assinaturas.forEach((assinatura) => {
          if (
            assinatura.atividadeNome == enviarAssinaturaForm.value.atividadeNome
          ) {
            assinaturaRemoverId.value = assinatura.assinaturaId;
          }
        });
        removerAssinatura();
      }
    };

    const removerAssinatura = async () => {
      try {
        await store.dispatch("pdt/removerAssinatura", {
          ptId: props.assinante.ptId,
          assinaturaId: assinaturaRemoverId.value,
        });
        quasar.notify({
          message: "Assinatura removida com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("voltar");
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o excluir assinatura",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviarAssinatura = async ({
      ptId,
      atividadeNome,
      assinanteId,
      assinanteTipo,
      participaAtividade,
      assinaturaTipo,
      assinatura,
    }) => {
      try {
        await store.dispatch("pdt/enviarAssinatura", {
          ptId,
          atividadeNome,
          assinanteId,
          assinanteTipo,
          participaAtividade,
          assinaturaTipo,
          assinatura,
        });

        const assinaturaExiste = assinaturasLocais.value.some(
          (ass) => ass.atividadeNome === atividadeNome
        );

        if (!assinaturaExiste) {
          assinaturasLocais.value.push({
            atividadeNome,
            assinaturaTipo,
            participaAtividade,
            assinatura,
            assinaturaId: Date.now(),
          });
        }

        setTimeout(() => {
          navegarParaProximaAtividade();
        }, 50);

        restartSignature.value += 1;
        imagemBase64.value = null;
      } catch (error) {
        const mensagemErro =
          error?.response?.data?.erro?.mensagem || "Erro ao enviar assinatura";

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        throw error;
      }
    };

    const biometriaVerificacao = (value) => {
      biometriaVerificacaoConst.value = value;

      setTimeout(() => {
        biometriaModal.value = false;
      }, 100);

      // Removendo a chamada automática - só deve processar quando clicar no botão "Confirmar Assinatura"
      if (value) {
        quasar.notify({
          message:
            "Biometria verificada com sucesso! Clique em 'Confirmar Assinatura' para continuar.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    const verificarPin = async () => {
      if (pin.value == "") {
        quasar.notify({
          message: "O campo não pode estar vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        return false;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: props.assinante.executanteId,
        });
        if (response.data.result.pin_correto) {
          quasar.notify({
            message: "PIN validado com Sucesso.",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

          return true;
        } else {
          quasar.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return false;
        }
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return false;
      }
    };

    const fecharFacial = async () => {
      facial.value = false;
    };

    const receberFace = async (faceImage) => {
      imagemBase64.value = faceImage;

      facial.value = false;

      quasar.notify({
        message: "Face recebida com sucesso",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const isAtividadeAssinada = (atividade) => {
      return assinaturasLocais.value.some(
        (assinatura) => assinatura.atividadeNome === atividade
      );
    };

    return {
      coletar,
      enviarAssinaturaForm,
      atividadesOptions,
      atividadesCriticas,
      assinaturasAssinadas,
      atualizarImagem,
      coletarAssinatura,
      coletarBiometria,
      restartSignature,
      saveSignature,
      salvarSignature,
      listaAtividades,
      verificaAssinaturas,
      atividadeLista,
      verificarAssinaturaRemover,
      assinaturaRemoverId,
      removerAssinatura,
      tipoTitulo,
      biometriaModal,
      biometriaVerificacao,
      biometriaVerificacaoConst,
      atualizarBiometria,
      pin,
      facial,
      fecharFacial,
      receberFace,
      imagemBase64,
      coletarImagem,
      isAtividadeAssinada,
      navegarParaProximaAtividade,
      mapearAssinaturaTipo,
      coletarBiometriaDigital,
      adicionarMetadadosAssinatura,
    };
  },
};
</script>
<style scoped>
.canvas-container {
  width: 700px;
}
.assinatura-texto {
  font-size: 17px;
}
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
@media (max-width: 600px) {
  .canvas-container {
    width: 100%;
  }
  .assinatura-texto {
    font-size: 14px;
  }
}
</style>
